(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.shopify-section-group-header-group');
    this.wrapper = this.header?.querySelector('.header-wrapper');
    this.lastScroll = 0;
    this.originalTransparentClass = '';
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.saveOriginalTransparentClass();
  }

  saveOriginalTransparentClass() {
    if (!this.wrapper) return;
    const classes = ['header--transparent-white', 'header--transparent-black'];
    this.originalTransparentClass = classes.find(cls => this.wrapper.classList.contains(cls)) || '';
  }

  onScroll() {
    if (!this.wrapper) return;
    const current = window.scrollY;
    const scrollingDown = current > this.lastScroll;
    const scrolledPastTop = current > 10;

    if (scrollingDown && scrolledPastTop) {
      this.wrapper.classList.add('header-wrapper--hidden');
    } else {
      this.wrapper.classList.remove('header-wrapper--hidden');
    }

    if (scrolledPastTop) {
      this.wrapper.classList.add('scrolled-past-header');
      if (this.originalTransparentClass) this.wrapper.classList.remove(this.originalTransparentClass);
    } else {
      this.wrapper.classList.remove('scrolled-past-header');
      if (this.originalTransparentClass) this.wrapper.classList.add(this.originalTransparentClass);
    }
    this.lastScroll = current;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
